import React from 'react';

function Footer() {
  return (
    <footer className='py-2' style={{ backgroundColor: '#eee', marginTop: 'auto' }}>
      <p>&copy; 2025 ILMS App</p>
    </footer>
  );
}

export default Footer;
